export enum ApayloId {
  PREFIX = 'APL3939'
}
